<template>
  <div class="flex flex-col static space-y-2 w-full h-full mb-16 px-5">
    <div class="flex items-center justify-between py-2">
      <div class="flex items-center space-x-3">
        <img class="avatar w-8 h-8 rounded-full" src="/static/roundtable_options_create/genie_icon.svg"/>
        <span class="font-semibold font-poppins text-gray-800 text-base"> Genie Recap </span>
      </div>
      <button @click="handleRefreshRecap()" title="Refresh" v-if="genieRecap && hasTeacherPermissionsInCourse"  class="w-7 h-7 bg-blueGray-50 border border-solid hover:bg-blueGray-100 text-blueGray-600 hover:text-blueGray-700 border-blueGray-600 rounded-full">
        <i class="fa-solid text-sm fa-rotate " :class="isGenerating === true ? 'animate-spin' : ''"></i>
      </button>
    </div>
    <div class="h-full flex flex-col flex-grow">
      <div v-if="genieRecap !== null" class="flex flex-col">
        <div>
          <div v-html="genieRecap.prompt_summary" class="font-poppins text-gray-700 font-normal"></div>
        </div>
        <div v-if="hasTeacherPermissionsInCourse" class="flex flex-col space-y-4 mb-6">
          <div class="flex items-center space-x-3 text-base text-pinky">
            <i class="fa-solid fa-thumbtack"></i>
            <h5 class="font-poppins font-semibold">Follow Up Questions</h5>
          </div>
          <div v-for="(q, index) in genieRecap.questions" :key="index" class="mb-3">
            <span> <span class="font-poppins text-gray-700 font-semibold">{{ index + 1 }}.</span> <span class="font-normal text-gray-700 font-poppins">{{ q.question }}</span></span>
          </div>
        </div>
        <div v-if="hasTeacherPermissionsInCourse" class="flex flex-col space-y-4">
          <div class="flex items-center space-x-3 text-base text-gray-700">
            <i class="fa-solid fa-share text-gray-700 text-base"></i>
            <h5 class="font-poppins font-semibold">Share Follow Up Questions</h5>
          </div>
          <div class="flex flex-col space-y-2.5">
            <button @click="handleOpenCurrentFollowUpOption()" class="sample px-5 py-3.5 border hover:border-gray-300 border-gray-200 hover:bg-gray-50 text-left border-solid rounded cursor-pointer disabled:opacity-60">
              <div class="flex items-center space-x-4">
                <img src="/static/roundtable_options_create/current_roundtable_icon.svg" class="w-8 h-8" />
                <div class="flex flex-col">
                  <h6 class="font-medium text-gray-700">Current RoundTable</h6>
                  <span class="text-xs text-gray-400 font-poppins font-light">
                    Students can comment one the Genie Recap thread
                  </span>
                </div>
              </div>
            </button>
            <button @click="handleStartFollowUp('written')" class="px-5 py-3.5 border hover:border-gray-300 text-left hover:bg-gray-50 border-gray-200 border-solid rounded cursor-pointer disabled:opacity-60">
              <div class="flex items-center space-x-4">
                <div class="flex items-center justify-center rounded-full h-8 w-8 bg-blue">
                  <img src="/static/roundtable_icons/written_icon.svg" class="w-4 h-4" />
                </div>
                <div class="flex flex-col">
                  <h6 class="font-medium text-gray-700">Written RoundTable</h6>
                  <span class="text-xs text-gray-400 font-poppins font-light">
                    Create a new Written RoundTable for the class
                  </span>
                </div>
              </div>
            </button>
            <button @click="handleStartFollowUp('verbal')" class="px-5 py-3.5 border hover:border-gray-300 hover:bg-gray-50 border-solid text-left border-gray-200 rounded cursor-pointer disabled:opacity-60">
              <div class="flex items-center space-x-4">
                <div class="flex items-center justify-center rounded-full h-8 w-8 bg-green-light">
                  <img src="/static/roundtable_icons/verbal_icon.svg" class="w-4 h-4" />
                </div>
                <div class="flex flex-col">
                  <h6 class="font-medium text-gray-700">Verbal RoundTable</h6>
                  <span class="text-xs text-gray-400 font-poppins font-light">
                    Create a new Verbal RoundTable for the class
                  </span>
                </div>
              </div>
            </button>
          </div>          
        </div>
      </div>
      <div v-else-if="hasTeacherPermissionsInCourse && genieRecap === null" class="flex flex-col space-y-4">
        <span class="font-poppins font-light text-gray-800">
          Ask the Genie to summarize turn by turn from all discussion and generate follow up questions!
        </span>
        <button @click="handleCreateGenieRecap()" class="px-4 py-2 bg-pink-50 border border-solid border-pinky rounded-md text-pinky font-semibold hover:bg-pink-100">
          Generate
        </button>
      </div>
    </div>
    <div class="flex justify-start text-blueGray-800 py-3 text-xs font-poppins font-light">
      <span>Powered by Parlay Genie</span>
    </div>
  </div>
</template>
<script>
  import Vue from 'vue';
  import Axios from 'axios';
  import { mapGetters } from 'vuex';
import { EventBus } from '../../../utils/event-bus';
  export default Vue.extend({
    data() {
      return {
        isGenerating: false,
        summary: '',
        formattedResponse: '',
        isLoading: false,
        genieRecap: null
      };
    },
    computed: {
      ...mapGetters(['hasTeacherPermissionsInCourse', 'getCurrentDiscussion', 'getProfile']),
      canCreateActivities() {
        return Boolean(
          this.getProfile.is_paid || this.getProfile.activity_passes
        );
      },
    },
    methods: {
      handleRefreshRecap: async function() {
        this.isGenerating = true;
        try {
          const { data } = await Axios.get(`/api/verbal_recaps/verbal_discussion/${this.getCurrentDiscussion.id}`);

          this.genieRecap = data;
          const [summary, followUpQuestions ] = await Promise.all([
            await Axios.post(`/api/verbal_recaps/${data.id}/verbal_discussion/${this.getCurrentDiscussion.id}/summary`),
            await Axios.post(`/api/verbal_recaps/${data.id}/verbal_discussion/${this.getCurrentDiscussion.id}/follow-up-questions`)
          ]);

          const summaryText = this.handleFormatText(summary.data.data);
          this.genieRecap.prompt_summary = summaryText;
          this.genieRecap.questions = followUpQuestions.data.data;

          if (data.id) {
            this.$store.commit("UPDATE_VERBAL_RECAP", this.genieRecap);
          }
          this.isGenerating = false;

        } catch (error) {
          this.isGenerating = false;
          console.log(error);
        }
      },
      handleGetGenieRecap: async function() {
        try {
          this.isLoading = true;
          this.genieRecap = this.getCurrentDiscussion.genie_recap;
          this.genieRecap.prompt_summary = this.handleFormatText(this.getCurrentDiscussion.genie_recap.prompt_summary);
          this.isLoading = false;
        } catch (error) {
          console.log(error);
        }
      },
      handleCreateGenieRecap: async function() {
        const toast = { type: 'Info', message: '', time: 5000 };
        if (!this.getCurrentDiscussion.transcriptions) {
          toast.message = 'Sorry! It is only possible generate a Recap if a transcript exists';
          EventBus.$emit('createToast', toast);
          return;
        }
        try {
          this.isGenerating = true;
          const { data } = await Axios.post(`/api/verbal_recaps`, { live_discussion_id: this.getCurrentDiscussion.id });

          if (data.id) {
            this.$store.commit("UPDATE_VERBAL_RECAP", data);
          }

          this.genieRecap = data;
          const [summary, followUpQuestions ] = await Promise.all([
            await Axios.post(`/api/verbal_recaps/${data.id}/verbal_discussion/${this.getCurrentDiscussion.id}/summary`),
            await Axios.post(`/api/verbal_recaps/${data.id}/verbal_discussion/${this.getCurrentDiscussion.id}/follow-up-questions`)
          ]);


          const summaryText = this.handleFormatText(summary.data.data);
          this.genieRecap.prompt_summary = summaryText;
          this.genieRecap.questions = followUpQuestions.data.data;

          if (data.id) {
            this.$store.commit("UPDATE_VERBAL_RECAP", this.genieRecap);
          }

          this.isGenerating = false;
        } catch (error) {
          console.log(error);
        }
      },
      handleFormatText(text, sentencesPerParagraph = 2) {
        const cleanedText = text.replace(/<[^>]+>/g, '');
        // eslint-disable-next-line no-useless-escape
        const sentences = cleanedText.match(/[^\.!\?]+[\.!\?]+/g);

        if (!sentences) return text;

        const paragraphs = [];
        for (let i = 0; i < sentences.length; i += sentencesPerParagraph) {
          const paragraphSentences = sentences.slice(
            i,
            i + sentencesPerParagraph
          );
          const paragraph = paragraphSentences.join(' ');
          paragraphs.push(paragraph);
        }

        return paragraphs.map((p) => `<p>${p.trim()}</p><br/>`).join('');
      },
      handleOpenCurrentFollowUpOption: async function() {        
        EventBus.$emit('handleTab', 'discussion');
        EventBus.$emit('handleOpenGuidingQuestionsModal'); 
      },
      handleStartFollowUp: async function(roundtable_type) {
        const toast = { type: 'Info', message: '', time: 5000 };
        if (!this.canCreateActivities) {
          toast.message = 'You have (0) RoundTables left. Want more? Delete old ones or upgrade account.';
          EventBus.$emit('createToast', toast);
          return;
        }
        if (this.limitOfRoundtablesInSequence) {
          toast.message = 'You have reached the limit of RoundTables per Sequence (5).';
          EventBus.$emit('createToast', toast);
          return;
        }
        this.$emit('startFollowUp', roundtable_type);
      }
    },
    mounted: async function () {    
      const { handleGetGenieRecap } = this;
      await handleGetGenieRecap();
    },
  });
</script>
<style scoped>
  .genie-background {
    background: rgb(12, 112, 168);
    background: linear-gradient(
      47deg,
      rgba(12, 112, 168, 0.2) 0%,
      rgba(255, 35, 165, 0.3) 100%
    );
  }
</style>



// WEBPACK FOOTER //
// GenieRecapVerbal.vue?3f21357c